define.alias("ember-cli-string-helpers/helpers/capitalize", "calendar/helpers/capitalize");